import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import CheckmarkSwitch from 'components/CheckmarkSwitch';
import { Typography } from '@redshelf/redshelf-ui';

const useStyles = makeStyles((theme) => {
  return {
    keyboardShortcutsToggle: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',

      padding: theme.spacing(0.125, 1, 0.125, 2),
      border: `1px solid ${theme.palette.grey[300]}`,
      background: theme.palette.grey[100],
      borderRadius: '4px',
    },
    switchToggleLabelRoot: {
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
      margin: 0,
      padding: `${theme.spacing(0.125, 1, 0.125, 2)}`,
      userSelect: 'none',
    },
    switchToggleLabel: {
      ...theme.typography.h6,
    },
  };
});

const KeyboardShortcutsToggle = ({
  isEnabled,
  onToggle,
  className,
  children,
  ...props
}) => {
  const classes = useStyles();

  return (
    <div className={classes.keyboardShortcutsToggle} {...props}>
      <Typography
        className={classes.switchToggleLabel}
        component="h3"
        id="shortcuts-title"
      >
        Enable Keyboard Shortcuts
      </Typography>
      <CheckmarkSwitch
        isEnabled={isEnabled}
        onToggle={onToggle}
        color="primary"
        name="keyboardShortcutsSwitch"
        inputProps={{
          'aria-labelledby': 'shortcuts-title',
        }}
      />
    </div>
  );
};

KeyboardShortcutsToggle.propTypes = {
  isEnabled: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
};

export default KeyboardShortcutsToggle;
